export default "__VITE_ASSET__mHzHDPGk__"